module.exports = __webpack_public_path__ + "hero.0039d0f888627492def1.jpg";


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/assets/img/hero.jpg
// module id = ../../../../../client/assets/img/hero.jpg
// module chunks = styles